export const DEFAULT_MAX_SCORE = 500;
export const DEFAULT_BAR_HEIGHT = 12;

export const SCORE_LEVEL = {
  CONVERSANT: 'Conversant',
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
};
